let app = {
  ssl: 'SSL',
  noSsl: 'Sem SSL',
  online: 'Online',
  offline: 'Sem Internet',
  connected: 'Conectado',
  disconnected: 'Desconectado',
  reload: 'Atualizar',
  force_reload: 'Forçar Atualização',
  auto_updates_on: 'Atualização Automática ativa'
}

export default app
